import { Component, OnInit } from '@angular/core';
import { KudosService } from 'src/app/providers/kudos/kudos.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';

@Component({
  selector: 'app-microloan',
  templateUrl: './microloan.component.html',
  styleUrls: ['./microloan.component.scss']
})
export class MicroloanComponent implements OnInit {

  constructor(private kudosServe: KudosService,
              private notifyService: NotificationService) { }

  ngOnInit(): void {
    this.loanRequest();
  }

  loanRequest(): void {
    // tslint:disable-next-line: deprecation
    this.kudosServe.microLoanRequest({rqst_source: 'WEB'}).subscribe(res => {
      if (res.status) {
        this.notifyService.showSuccess(res.msg, 'Success!');
      } else {
        this.notifyService.showInfo(res.msg, 'Info!');
      }
    });
  }
}
